export default __webpack_public_path__ + "static/media/Admitidos_Ordenamento2023_24.1832a71e.pdf";